module.exports = __webpack_public_path__ + "media/images/social/twitter-985c883a605abd4aec35fc30fa39cc6e.svg";